import { signal } from "@preact/signals-react";

type TaskTimerStateType = { isTimerRunning: true; taskDuration: number; taskTitle: string } | { isTimerRunning: false };

export const taskTimerState$ = signal<TaskTimerStateType>({ isTimerRunning: false });

export const startTaskTimer = (taskDurationMins: number, taskTitle: string, onStart: () => void) => {
    taskTimerState$.value = { isTimerRunning: true, taskDuration: taskDurationMins, taskTitle };
    onStart();
};
